import { isToday } from '../helpers/common';
import { egAnalyzeInfo, workedKPI, getAnalyzeTopics } from '../actions/analyze';
import {
    LIVE_MESSAGE, OPERATOR_ANALYZE_INFO, PLAN_ANALYZE_INFO, GET_GRAPH, GET_WORKED_KPI, SET_SEARCH_PARAMS
} from '../constants/action-types';

const pipePhaseToAnalyzeLiveData = (store, action) => {
    if (!action.message) return;
    const state = store.getState();
    const search = state.analyze.searchParams;

    if (!isToday(search.range)) return;
    const live = action.message;
    const analyze = state.analyze.analyzeParams;
    const topics = getAnalyzeTopics(analyze);

    const findTopics = topics.filter(e => e.subscribeDeviceId === live.deviceId &&
        e.topic ? e.topic === live.name : e.action === live.action);
    if (findTopics.length === 0) return;

    const item = findTopics[0];
    const data = live.initial ? live.message.data : live.message;
    const liveData = {
        [item.keyname]: {
            data,
            deviceId: live.deviceId,
            range: search.range,
            isLive: true
        }
    };
    return store.dispatch(workedKPI(liveData));
}

const operatorAnalyze = (store, action) => {
    let egItem = store.getState().map.egList.filter(e => e.operatorId === action.operatorId);
    egItem = (egItem.length > 0) ? egItem[0] : null;
    if (egItem) {
        const crewId = egItem.crews && egItem.crews.length > 0 ? egItem.crews[egItem.crews.length - 1].crew_uuid : null;
        store.dispatch(egAnalyzeInfo(crewId, egItem.crews, egItem.egId, egItem.name, egItem.isTruck, egItem.categeryId));
    }
    else store.dispatch(egAnalyzeInfo(null, [], null, action.title, null, null));
}

const analyzeMiddleware = store => {
    return next => action => {
        switch (action.type) {
            case SET_SEARCH_PARAMS:
                action = {
                    ...action,
                    payload: {
                        ...action.payload,
                        timezone: store.getState().farm.currentFarm.timezone_identifier
                    }
                }
                break;
            case LIVE_MESSAGE:
                pipePhaseToAnalyzeLiveData(store, action);
                break;
            case PLAN_ANALYZE_INFO:
                action = { ...action, payload: { ...action.payload, title: store.getState().farm.currentFarm.farm_name } };
                break;
            case GET_GRAPH:
                action = {
                    ...action,
                    timezone: store.getState().farm.currentFarm.timezone_identifier
                };
                break;
            case GET_WORKED_KPI:
                action = {
                    ...action,
                    timezone: store.getState().farm.currentFarm.timezone_identifier
                };
                break;
            case OPERATOR_ANALYZE_INFO:
                operatorAnalyze(store, action);
                break;
            default:
                break;
        }

        return next(action);
    };
};

export default analyzeMiddleware;